window.app_models.company_contact = {
    id:null,
    start_date:null,
    end_date:null,
    office:null,
    office_ext:null,
    fax:null,
    contact_id: null,
    company_id: null,
    housing_fee_type_id: null,
    pays_directly: null,
    pays_electronically: null,
    negotiated_fees: null,
    company: window.app_models.company
};



// WEBPACK FOOTER //
// ./resources/assets/js/models/company_contact.js